import ImmutableModel, {
  asString,
  asInstance,
  asBoolean,
  asNullOr,
  withDefault
} from '@aytm/lib/immutable/ImmutableModel'
import ItemsOrderedMap from '@aytm/lib/immutable/ItemsOrderedMap'
import ListModel from '@aytm/lib/immutable/ListModel'
import { asRequiredUID } from '@aytm/app/insights/dashboard/lib/immutable'

export const GroupItemsListModel = ListModel(asString, 'GroupItemsListModel')

export const MethodListModel = ListModel(asString, 'MethodListModel')

class MetricItemModel extends ImmutableModel({
  uid: asString,
  values: asInstance(MethodListModel.isMethodListModel, MethodListModel),
  method: asNullOr(asString),
  disabled: asInstance(MethodListModel.isMethodListModel, MethodListModel),
  show: withDefault(true, asBoolean)
}) {}
ImmutableModel.decorator({ name: 'MetricItemModel' })(MetricItemModel)

export const MetricsOrderedMap = ItemsOrderedMap(
  x => (MetricItemModel.isMetricItemModel(x) ? x : MetricItemModel.of(x)),
  null,
  'MetricsOrderedMap'
)

/**
 * @class GroupModel
 * @extends ImmutableModel
 *
 */
class GroupModel extends ImmutableModel({
  name: asString,
  target: asString,
  items: asInstance(GroupItemsListModel.isGroupItemsListModel, GroupItemsListModel),
  disabled: asInstance(GroupItemsListModel.isGroupItemsListModel, GroupItemsListModel),
  collapsed: withDefault(false, asBoolean),
  metrics: asInstance(MetricsOrderedMap.isMetricsOrderedMap, MetricsOrderedMap)
}) {}
ImmutableModel.decorator({ name: 'GroupModel' })(GroupModel)

/**
 * @class MilestoneModel
 * @extends ImmutableModel
 * @static { (unknown) => MilestoneModel } of
 * @property {string} uid
 * @property {string} title
 * @property {string} date
 * */
class MilestoneModel extends ImmutableModel({
  uid: asRequiredUID(),
  title: asNullOr(asString),
  date: asNullOr(asString)
}) {}
ImmutableModel.decorator({ name: 'MilestoneModel' })(MilestoneModel)

export { GroupModel, MetricItemModel, MilestoneModel }
